import HarleyFreespinRecord from "integration/records/freespin-record";
import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import translations from "slotworks/i18n/translations";
import { SpinRecordBuilder } from "slotworks/integration/revolver/builders/records/spin-record-builder";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import { SpinResponseSchema } from "slotworks/integration/revolver/schema/spin-record-schema";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import builderManager from "slotworks/server/builders/builder-manager";
import freespinsWheelResultBuilder from "./freespins-wheel-result-builder";
import wheelBonusResultBuilder from "./wheel-bonus-result-builder";

class HarleySpinRecordBuilderBase extends SpinRecordBuilder {

    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;

        if (data) {
            spinResponse = data.data as SpinResponseSchema;
        }
        
        return spinResponse && spinResponse.RESULTS !== undefined && 
                ((revolverModel.isSpin(spinResponse.RESULTS.game) && !(spinResponse.RESULTS.state?.game === "BUYOUT")) || 
                (revolverModel.isFreespin(spinResponse.RESULTS.game) && spinResponse.RESULTS.game !== "FREESPIN_WHEEL_BONUS"));
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const records = super.build(gameplay, data);
        let spinResponse: SpinResponseSchema;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
        }
        
        if(gameplay.inFreespinsGame && spinResponse.RESULTS?.state?.is_retrigger) {
            const record = records[0] as HarleyFreespinRecord;
            record.retrigger = true;
            record.freespinsWon = (spinResponse.RESULTS?.state as any).spins_won;
        }

        if(gameplay.inFreespinsGame) {
            const record = records[0] as HarleyFreespinRecord;
            record.giftedAdditional = (spinResponse.RESULTS?.state as any).giftedAdditional || 0;
        }

        if(records && records[0] instanceof SpinRecord && !(records[0] instanceof FreespinRecord)) {
            const bet = spinResponse.RESULTS.total_bet_cash;

            if (bet > 0 && betModel.getTotalBet() != bet) {
                FatalErrorCommand(translations.get("@err_server_generic"));               
            }
        }

        return records;
    }

    // is_retrigger
    protected processOtherResult(spinRecord: SpinRecord, spinResponse: SpinResponseSchema) {
        let results = builderManager.buildResult(spinRecord, spinResponse);
        
        if(freespinsWheelResultBuilder.filter(spinResponse)) {
            results = results.concat(freespinsWheelResultBuilder.build(spinRecord, spinResponse));
        }

        if(wheelBonusResultBuilder.filter(spinResponse)) {
            results = results.concat(wheelBonusResultBuilder.build(spinRecord, spinResponse));
        }

        spinRecord.results = spinRecord.results.concat(results);
    }
}

const HarleySpinRecordBuilder = new HarleySpinRecordBuilderBase();
export default HarleySpinRecordBuilder;